import  gql  from 'graphql-tag'

export const amountTermsWc = gql`query amountTermsWc{ 
    amountTermsWc{
            edges{
                node{
                    id,
                    data
                }
            }
        }
    }`;
